import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface IPercentIncreaseCellRendererParams extends ICellRendererParams {
    value: (params, year: number) => number;
    year: number;
}

@Component({
    selector: 'cap-rule-percent-increase',
    template: `<span>{{increase | percent: '1.6-6'}}</span>`,
    standalone: false
})
export class PercentIncreaseCellRenderer implements ICellRendererAngularComp {
    increase: number;

    agInit(params: IPercentIncreaseCellRendererParams): void {
        this.increase = params.value(params, params.year);
    }

    refresh(): boolean {
        return false;
    }
}
